import { render, staticRenderFns } from "./NameHotel.vue?vue&type=template&id=98ff9cdc&"
import script from "./NameHotel.vue?vue&type=script&lang=js&"
export * from "./NameHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VChip,VRating})
